import HotelMetricsColumns from '../common-columns/hotel-metrics-columns';

export function getName({
  CampaignId, // actually sub account id
}) {
  if (CampaignId) {
    return 'HotelSubAccountGrid';
  }
  return 'AllSubAccountHotelSubAccountGrid';
}

export function getColumnsMetadata() {
  return HotelMetricsColumns;
}

export function getPage() {
  return 'HotelCenter';
}

export function getRoute() {
  return 'overview/grid-chooser-item-subaccount';
}
